import editUser from '@/core/components/editUser'
import authDistributed from './../components/authorityDistributed.vue'
import store from '@/store'
export default {
  className: '_User',
  fields: [

    'name',
    'username',
    'company',
    // {
    //   name: 'adminRole',
    //   width: 150
    // },
    {
      name: 'allClient',
      note: '客户权限'
    },
    {
      name: 'allShopManagements',
      note: '车间权限'
    },
    {
      name: 'allBatching',
      note: '配样权限'
    },
    'shopManagements',
  ],
  search: [
    'name',
    'username'
  ],
  action: {
    create: store.state.user && store.state.user.authority.user.create
      ? {
        title: '添加用户',
        component: editUser
      } : false,
    edit: store.state.user && store.state.user.authority.user.edit
      ? {
        title: '编辑用户',
        component: editUser
      } : false,
    // authDistributed: store.state.user && store.state.user.distribution === 'Yes'
    authDistributed: store.state.user && store.state.user.authority.user.edit
      ? {
        type: 'row',
        title: '权限分配',
        text: '权限分配',
        component: authDistributed
      } : false,
    reset: store.state.user && store.state.user.authority.user.edit
      ? {
        text: '重置密码',
        type: 'row',
        callback: async ({ record, vm, modelName }) => { // 点击按钮后触发的callback回调，参数中的 record代表被点击行的数据，vm为vue实例
          await vm.confirm('警告', '你确定要重置密码吗?')
          let rs = await vm.$modelAjax.put(modelName, record.objectId, {
            password: '123456'
          }).catch(() => {
            this.$notification['error']({
              message: '网络错误',
              description: '重置密码失败'
            })
          })
          if (rs) {
            vm.$notification['success']({
              message: '操作成功',
              description: '密码已被重置为123456'
            })
            vm.refresh() // 你可以调用refresh与reset方法来刷新页面，区别为reset会重置查询条件，排序，翻页页数
          }
        }
      } : false,
    delete: store.state.user && store.state.user.authority.user.del ? {} : false
  }
}
